"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useL10nUnitsContext = exports.L10nUnitsProvider = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const L10nUnitsContext = /*#__PURE__*/(0, _react.createContext)();
const L10nUnitsProvider = _ref => {
  let {
    children,
    selected
  } = _ref;
  const [{
    length,
    weight,
    glucose
  }, setUnits] = (0, _react.useState)(selected);
  const value = (0, _react.useMemo)(() => ({
    length,
    weight,
    glucose,
    onChange: setUnits
  }), [length, weight, glucose]);
  (0, _react.useEffect)(() => {
    setUnits(selected);
  }, [selected]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(L10nUnitsContext.Provider, {
    value: value,
    children: children
  });
};
exports.L10nUnitsProvider = L10nUnitsProvider;
const useL10nUnitsContext = () => (0, _react.useContext)(L10nUnitsContext);
exports.useL10nUnitsContext = useL10nUnitsContext;